import { render, staticRenderFns } from "./DetailTextModal.vue?vue&type=template&id=47d810a4&scoped=true"
import script from "./DetailTextModal.vue?vue&type=script&lang=js"
export * from "./DetailTextModal.vue?vue&type=script&lang=js"
import style0 from "./DetailTextModal.vue?vue&type=style&index=0&id=47d810a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d810a4",
  null
  
)

export default component.exports